import { URLS } from '~/common/constants'
import { METHODS } from '~/common/constants/http'
import { factoryRequest } from '~/common/utils/request'

export const apiGetVisit = async () => {
  const send = factoryRequest(METHODS.GET, URLS.VISIT_URL)
  const { result } = await send()
  return result
}
